import { EnvironmentProviders, Inject, Injectable, Provider } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { DefaultMatCalendarRangeStrategy, MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

const dateLocalFactory = (i18next: ITranslationService) => i18next.language;

export const SHARRY_DATE_FORMATS = {
  parse: {
    dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@Injectable()
export class SharryDateAdapter extends NativeDateAdapter {
  constructor(@Inject(MAT_DATE_LOCALE) private matDateLocale: string) {
    super(matDateLocale);
  }
  parse(value: any): Date | null {
    if (typeof value === 'string' && value.indexOf('/') > -1) {
      const str = value.split('/');
      if (str.length < 2 || isNaN(+str[0]) || isNaN(+str[1]) || isNaN(+str[2])) {
        return null;
      }
      return new Date(Number(str[2]), Number(str[1]) - 1, Number(str[0]), 12, 0, 0, 0);
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }
  format(date: Date, displayFormat: Intl.DateTimeFormatOptions | 'input'): string {
    if (displayFormat === 'input') {
      const day = date.getDate().toLocaleString(this.matDateLocale, { minimumIntegerDigits: 2, useGrouping: false });
      const month = (date.getMonth() + 1).toLocaleString(this.matDateLocale, {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      const year = date
        .getFullYear()
        .toLocaleString(this.matDateLocale, { minimumIntegerDigits: 4, useGrouping: false });
      // Return the format as per your requirement
      return `${day}/${month}/${year}`;
    } else {
      return date.toLocaleDateString(this.matDateLocale, displayFormat);
    }
  }
  getFirstDayOfWeek(): number {
    return 1;
  }
}
export const DATE_PROVIDERS: (Provider | EnvironmentProviders)[] = [
  {
    provide: MAT_DATE_LOCALE,
    useFactory: dateLocalFactory,
    deps: [I18NEXT_SERVICE],
  },
  { provide: DateAdapter, useClass: SharryDateAdapter, deps: [MAT_DATE_LOCALE] },
  {
    provide: MAT_DATE_FORMATS,
    useValue: SHARRY_DATE_FORMATS,
  },
  {
    provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
    useClass: DefaultMatCalendarRangeStrategy,
  },
];
